import type { HTMLAttributes, ReactNode } from 'react';

import { cn } from '../../lib/utils';

interface FieldLabelProps {
    label: ReactNode;
    className?: string;
    htmlFor?: string;
    disabled?: boolean;
    required?: boolean;
    dataTestid?: string;
    htmlAttributes?: HTMLAttributes<HTMLLabelElement>;
}

export const FieldLabel = ({
    label,
    required = false,
    disabled = false,
    htmlFor,
    className,
    dataTestid,
    htmlAttributes,
}: FieldLabelProps) => (
    <label
        className={cn(
            'block truncate text-xs font-medium leading-4',
            disabled ? 'text-gray-400' : 'text-gray-800',
            className
        )}
        htmlFor={htmlFor}
        data-testid={dataTestid}
        {...{ ...htmlAttributes, 'aria-disabled': disabled }}
    >
        {label} {required && '*'}
    </label>
);
